import { inject, Injectable, Signal, signal } from '@angular/core';
import { ENVIRONMENT, Environment } from '@maia/config';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private environment: Environment = inject(ENVIRONMENT);

  public groupAppEnabled: Signal<boolean> = signal(this.environment.featureFlags.groupAppEnabled).asReadonly();
}
